module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "buy"
  }, [_c('div', {
    staticClass: "buy-topBar"
  }, [_c('span', {
    staticClass: "btn-back iconfont",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showBack($event)
      }
    }
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("双色球投注")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-content"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "btn addSelf",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addSelf($event)
      }
    }
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    staticClass: "btn-text"
  }, [_vm._v("自选号码")])]), _vm._v(" "), _c('div', {
    staticClass: "btn addChoice",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.choice()
      }
    }
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    staticClass: "btn-text"
  }, [_vm._v("机选1注")])]), _vm._v(" "), _c('div', {
    staticClass: "btn clear",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showClear($event)
      }
    }
  }, [_c('span', {
    staticClass: "btn-text"
  }, [_vm._v("清空列表")])])]), _vm._v(" "), _c('div', {
    staticClass: "top-pic"
  }, [_c('span', {
    staticClass: "pic-left"
  }, [_c('img', {
    attrs: {
      "src": require("../images/cpBarLeft.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "pic-center"
  }, [_c('img', {
    attrs: {
      "src": require("../images/cpBarCenter.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "pic-right"
  }, [_c('img', {
    attrs: {
      "src": require("../images/cpBarRight.png")
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "cp",
    staticClass: "cp-wrap"
  }, [_c('div', {
    staticClass: "cp-content"
  }, _vm._l((_vm.processList), function(item) {
    return _c('div', {
      key: item.index,
      staticClass: "cp-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleCp(item.index, $event)
        }
      }
    }, [_c('div', {
      staticClass: "btn-wrap",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.remove(item.index, $event)
        }
      }
    }, [_c('span', {
      staticClass: "btn-remove iconfont"
    }, [_vm._v("")])]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('p', {
      staticClass: "code"
    }, [_c('span', [_c('i', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.redCode))]), _c('i', {
      staticClass: "blueColor"
    }, [_vm._v(_vm._s(item.blueCode))])])]), _vm._v(" "), _c('p', {
      staticClass: "count"
    }, [_c('span', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.count) + "注")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.money) + "元")])])]), _vm._v(" "), _c('div', {
      staticClass: "icon-right"
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "buy-bottomBar"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-content input-left"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("连续买")]), _vm._v(" "), _c('span', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periods),
      expression: "periods"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.periods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periods = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("期")])]), _vm._v(" "), _c('div', {
    staticClass: "input-content input-right"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("投")]), _vm._v(" "), _c('span', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.multiple),
      expression: "multiple"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.multiple)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.multiple = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("倍")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "total-price"
  }, [_vm._v("共" + _vm._s(_vm.totalMoney) + "元")]), _vm._v(" "), _c('p', {
    staticClass: "total-count"
  }, [_vm._v(_vm._s(_vm.totalCount) + "注" + _vm._s(_vm.multiple) + "倍" + _vm._s(_vm.periods) + "期")]), _vm._v(" "), _c('span', {
    staticClass: "btn-buy",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buy()
      }
    }
  }, [_vm._v("付款")])])]), _vm._v(" "), _c('toolselect', {
    ref: "clearTool",
    attrs: {
      "titleText": "清空",
      "text": "您确定要清空当前的投注内容?"
    },
    on: {
      "sure": _vm.clear
    }
  }), _vm._v(" "), _c('toolselect', {
    ref: "backTool",
    attrs: {
      "btn-cancel": "清除",
      "btn-sure": "保持",
      "titleText": "退出",
      "text": "是否清除本次选号?"
    },
    on: {
      "sure": _vm.back,
      "cancel": _vm.backClear
    }
  }), _vm._v(" "), _c('toolselect', {
    ref: "resTool",
    attrs: {
      "btn-cancel": "了解",
      "btn-sure": "知道了",
      "titleText": "上传服务器",
      "text": _vm.resText
    },
    on: {
      "sure": function($event) {
        _vm.hideBuy()
      },
      "cancel": function($event) {
        _vm.hideBuy()
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b0e308e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ssc/component/buy.vue
// module id = 66
// module chunks = 0